import { Title } from '@angular/platform-browser';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, OnDestroy, OnInit, AfterContentChecked } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

import {
  ActionAuthLogin,
  ActionAuthLogout,
  routeAnimations,
  SessionStorageService,
} from '@app/core';

import { AppConfig } from '@app/config/app.config';
import { ProgressBarService } from '@app/shared/services/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { InfoService } from '@app/core/info/info.service';
import { EmergencyService } from '@app/core/auth/component/emergency-login/emergency-login.service';
import { environment } from '@env/environment';

@Component({
  selector: 'cloud-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations]
})
export class AppComponent implements OnDestroy, OnInit, AfterContentChecked {

  private unsubscribe$: Subject<void> = new Subject<void>();

  @HostBinding('class') componentCssClass = 'default-theme';

  logo = '../assets/images/logos/my-btrust-logo.svg';

  showEmergencyTitle: boolean;

  navigation = [
    { link: AppConfig.routes.certificates.sign, label: 'toSigning' }
  ];

  navigationSideMenu = [
    ...this.navigation,
    { link: AppConfig.routes.profile.main, label: 'profile' }
  ];

  constructor(
    public overlayContainer: OverlayContainer,
    private store: Store<any>,
    private info: InfoService,
    private router: Router,
    private progressBarService: ProgressBarService,
    private titleService: Title,
    private translateService: TranslateService,
    private emergency: EmergencyService,
    private sessionStorageService: SessionStorageService,
  ) { }

  ngOnInit() {
    const classList = this.overlayContainer.getContainerElement().classList;
    classList.add(this.componentCssClass);

    this.router.events
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(event => event instanceof ActivationEnd)
      )
      .subscribe((event: ActivationEnd) => {
        let lastChild = event.snapshot;
        this.info.dismissAll();
        this.progressBarService.setNull();

        while (lastChild.children.length) {
          lastChild = lastChild.children[0];
        }

        this.titleService.setTitle(environment.appName);
        if (lastChild.data.title) {
          this.translateService.stream(lastChild.data.title).subscribe((translateTitle) => {
            this.titleService.setTitle(translateTitle + ': ' + environment.appName);
          });
        }
      });
  }

  ngAfterContentChecked() {
    this.emergency.showEmergencyTitle.subscribe(value => {
      this.showEmergencyTitle = value;
      if (this.showEmergencyTitle) {
      const mainNavMenu = this.navigationSideMenu.find(e => e.link === AppConfig.routes.certificates.sign);
      mainNavMenu.label = 'toCertificates';
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onLoginClick() {
    this.store.dispatch(new ActionAuthLogin());
  }
  
  onLogoutClick() {
    this.store.dispatch(new ActionAuthLogout(false));
    this.sessionStorageService.clear();
  }
}
